import React, { useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    customDialog: {
        backgroundColor: '#ffffff',
        padding: theme.spacing(2),
        maxWidth: '700px',
    },
}));

const VideoModal = (props: any) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const classes = useStyles();

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.play().catch((error) => {
                console.log("Autoplay prevented by the browser:", error);
            });
        }
    }, []);

    const CloseButton = () => (
        <button onClick={props.handleClose} style={{ border: 'none', background: 'none' }}>
            <CloseIcon />
        </button>
    );

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.handleClose}
                maxWidth="md"
                fullWidth={true}
                classes={{ paper: classes.customDialog }}
            >
                <DialogTitle>
                    <div style={{ display: "flex", justifyContent: 'space-between' }}>
                        <div>Watch Video</div>
                        <div><CloseButton /></div>
                    </div>
                </DialogTitle>

                <DialogContent>
                    <div style={{ position: 'relative' }}>
                        <video ref={videoRef} width="100%" controls={true} autoPlay={true} muted={true}>
                            <source src={props.videoURL} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        {/* <div style={{ width: '100%', height: '100%' }}>
                            <iframe
                                width="100%"
                                height="100%"
                                src={`${props.videoURL}?autoplay=1&mute=1`} // Adding mute parameter
                                title="Video player"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen={true}
                            />

                        </div> */}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default VideoModal;



// WEBPACK FOOTER //
// ./src/shared/components/videoModal.tsx